import { Search } from "lucide-react";

import Select from "@components/ui-components/select";
import { KYC_STATUS_OPTIONS } from "@src/utility/constants/panel/common";
import { FILTER_ENDPOINTS } from "@constants/endpoints";

const PublishersFilterBar = ({ filters, onFilterChange }) => (
    <div className="mt-4 flex flex-wrap items-center gap-3">
        <div className="relative min-w-[220px] flex-1">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" />
            <input
                type="text"
                value={filters.search}
                onChange={(e) => onFilterChange({ search: e.target.value })}
                placeholder="Search publisher or email"
                className="w-full rounded-lg border border-gray-300 py-2.5 pl-9 pr-3 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20" />
        </div>
        <Select
            id="brand-filter"
            className="w-[220px]"
            placeholder="Any brand"
            URL={FILTER_ENDPOINTS.BRANDS}
            queryParams={{ limit: 10 }}
            value={filters.account_id}
            onChange={(account_id) => onFilterChange({ account_id })} />
        <Select
            id="kyc-status-filter"
            placeholder="Any KYC status"
            value={filters.kyc_status}
            options={KYC_STATUS_OPTIONS}
            onChange={(kyc_status) => onFilterChange({ kyc_status })} />
    </div>
);

export default PublishersFilterBar;
